exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1iorkk2Is94HTs7_43RUEA{height:16px;position:relative}._1iorkk2Is94HTs7_43RUEA div{display:inline-block}._20iTIF9-vNtbynHk41zNP->div{height:24px;width:24px}.KY1QbqZx9DEw5gqeGt2Nv{font-size:10px;color:var(--neutralSecondaryAlt);position:absolute;top:0}html[dir=ltr] .KY1QbqZx9DEw5gqeGt2Nv{padding-left:4px}html[dir=rtl] .KY1QbqZx9DEw5gqeGt2Nv{padding-right:4px}", ""]);
// Exports
exports.locals = {
	"indicatorContainer": "_1iorkk2Is94HTs7_43RUEA",
	"personaCoinFix": "_20iTIF9-vNtbynHk41zNP-",
	"isTypingText": "KY1QbqZx9DEw5gqeGt2Nv"
};